import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../stores/AppStore';
import {
  selectIsMentor,
  selectIsThinker,
  selectSubscriptionStatus,
} from '../features/user/userSlice';

export const ExpiredSubscriptionBanner: React.FC = () => {
  const isMentor = useAppSelector(selectIsMentor);
  const isThinker = useAppSelector(selectIsThinker);
  const subscriptionStatus = useAppSelector(selectSubscriptionStatus);
  const isMentorOrThinker = isMentor || isThinker;

  // Only show banner if subscription has expired for mentor/thinker users
  // Check for explicit cancellation/expiration, not just missing billing data
  const isExpiredSubscription =
    subscriptionStatus?.hasActiveSubscription === false &&
    (subscriptionStatus?.wasSubscribed === true ||
      (subscriptionStatus?.cancelAtPeriodEnd &&
        subscriptionStatus?.currentPeriodEnd &&
        new Date(subscriptionStatus.currentPeriodEnd) < new Date()));

  if (!isMentorOrThinker || !isExpiredSubscription) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <div className="bg-red-50 border-b border-red-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center">
            <svg
              className="h-5 w-5 text-red-600 mr-2 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <p className="text-sm text-red-800">
              <span className="font-medium">Subscription Expired:</span> Your
              subscription has expired. You can only view past results.
              {isThinker && (
                <> Please contact your Mentor to renew the subscription.</>
              )}
              {isMentor && (
                <> Renew your subscription to access all features.</>
              )}
            </p>
          </div>
          {isMentor && (
            <Link
              to="/manage-subscription"
              className="ml-4 flex-shrink-0 text-sm font-medium text-red-800 hover:text-red-900 underline"
            >
              Resubscribe Now
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpiredSubscriptionBanner;
